import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
import * as Utils from '_utils';
export function RenderGardenPumpButtonWidget(component) {
    return _jsx(GardenPumpButtonWidget, { id: component.properties.id });
}
export function RenderGardenPumpFrameWidget(component) {
    return _jsx(GardenPumpFrameWidget, { id: component.properties.id });
}
export function RenderGardenPumpScreenWidget(component) {
    return _jsx(GardenPumpScreenWidget, { id: component.properties.id });
}
export function GardenPumpButtonWidget(props) {
    return 'missing';
}
export function GardenPumpFrameWidget(props) {
    const spa = Common.useSpaContext();
    const pump = spa.state?.gardenPump;
    /*
 { "lastOff": "2025-09-19T19:17:00",
  "lastOn": "2025-09-19T19:02:00",
  "offIn": "900",
  "on": "False",
  "shouldRunAtEvening": "False",
  "shouldRunAtMorning": "False",
  "deviceId": "gardenPump",
  "lOff": "2025-09-19T19:17:00",
  "lon": "2025-09-19T19:02:00",
  */
    function toggle() {
        if (Utils.toBool(pump.on)) {
            // turn off
            Utils.Ajax.post('/house_api/command/gardenPump/stop');
        }
        else {
            // turn on
            Utils.Ajax.post('/house_api/command/gardenPump/start');
        }
    }
    return (_jsxs(Common.WidgetFrame, { children: [_jsx(Components.Property, { title: _jsx(Common.MLT, { id: "isOn" }), children: Utils.toBool(pump?.on) ? _jsx(Common.MLT, { id: "yes" }) : _jsx(Common.MLT, { id: "no" }) }), _jsx(Components.Button, { onClick: toggle, children: Utils.toBool(pump?.on) ? _jsx(Common.MLT, { id: "turnOff" }) : _jsx(Common.MLT, { id: "turnOn" }) })] }));
}
export function GardenPumpScreenWidget(props) {
    const spa = Common.useSpaContext();
    const pump = spa.state?.gardenPump;
    /*
 { "lastOff": "2025-09-19T19:17:00",
  "lastOn": "2025-09-19T19:02:00",
  "offIn": "900",
  "on": "False",
  "shouldRunAtEvening": "False",
  "shouldRunAtMorning": "False",
  "deviceId": "gardenPump",
  */
    function toggle() {
        if (Utils.toBool(pump.on)) {
            // turn off
            Utils.Ajax.post('/house_api/command/gardenPump/stop');
        }
        else {
            // turn on
            Utils.Ajax.post('/house_api/command/gardenPump/start');
        }
    }
    return (_jsxs(Common.WidgetFrame, { children: [_jsx(Components.Property, { title: _jsx(Common.MLT, { id: "isOn" }), children: Utils.toBool(pump?.on) ? _jsx(Common.MLT, { id: "yes" }) : _jsx(Common.MLT, { id: "no" }) }), _jsx(Components.Property, { title: _jsx(Common.MLT, { id: "lastOn" }), children: pump.lastOn ? new Date(pump.lastOn).toLocaleString() : _jsx(Common.MLT, { id: "never" }) }), _jsx(Components.Property, { title: _jsx(Common.MLT, { id: "lastOff" }), children: pump.lastOff ? new Date(pump.lastOff).toLocaleString() : _jsx(Common.MLT, { id: "never" }) }), _jsx(Components.Property, { title: _jsx(Common.MLT, { id: "shouldRunAtEvening" }), children: Utils.toBool(pump?.shouldRunAtEvening) ? (_jsx(Common.MLT, { id: "yes" })) : (_jsx(Common.MLT, { id: "no" })) }), _jsx(Components.Property, { title: _jsx(Common.MLT, { id: "shouldRunAtMorning" }), children: Utils.toBool(pump?.shouldRunAtMorning) ? (_jsx(Common.MLT, { id: "yes" })) : (_jsx(Common.MLT, { id: "no" })) }), _jsx(Components.Button, { onClick: toggle, children: Utils.toBool(pump?.on) ? _jsx(Common.MLT, { id: "turnOff" }) : _jsx(Common.MLT, { id: "turnOn" }) })] }));
}
